import React from 'react';
import './ResumeDialog.css';

const ResumeDialog = ({show, onClose, pdfUrl}) => {
    if(!show) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-button" onClick={onClose}>
            ×
          </button>
          <div className="modal-header">
            <h2>My Resume</h2>
          </div>
          <div className="modal-body">
            <iframe
              src={pdfUrl}
              title="Resume"
              width="100%"
              height="900px"
              style={{ border: 'none' }} 
            ></iframe>
          </div>
          <div className="modal-footer">
            <a href={pdfUrl} download="Abi_Resume.pdf" className="btn btn-primary">
              Download PDF
            </a>
            <button className="btn" onClick={onClose} style={{ marginLeft: '10px' }}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  export default ResumeDialog;
  